
import { phTestValidations } from './fdcOfflineFns';
import { getUpdatedFieldItems, resetCalibrationStatus, updateVerificationItems } from './formatFunction';
import { CACHE_APP_DATA, CACHE_KEY_MAP } from './offlineQueueUtils';

export async function updateTaskInCache(id, updatedTaskForms) {
  const cachedData = await getCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.DAILY_PLANNER_URL);
	if (!cachedData) return {};

	let taskList = Array.isArray(cachedData) ? cachedData : Array.isArray(cachedData?.data) ? cachedData.data : [];
	const taskIndex = taskList.findIndex(t => t.id === id);
	if (taskIndex === -1) return {};

  const task = taskList[taskIndex];
	await phTestValidations(task.taskForms, updatedTaskForms)
	task.taskForms = updatedTaskForms;
	const newData = Array.isArray(cachedData) ? taskList : {...cachedData, data: taskList};
  await updateCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.DAILY_PLANNER_URL, newData);
	
	// 🔑 Return the updated task
	return task;
}

export async function updateTaskStatusInCache(id, status) {
  const cachedData = await getCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.DAILY_PLANNER_URL);
	if (!cachedData) return {};

	let taskList = Array.isArray(cachedData) ? cachedData : Array.isArray(cachedData?.data) ? cachedData.data : [];
	const taskIndex = taskList.findIndex(t => t.id === id);
	if (taskIndex === -1) return {};

	// ✅ Update only status
  const task = taskList[taskIndex];
	task.status = status;
	const newData = Array.isArray(cachedData) ? taskList : {...cachedData, data: taskList};
  await updateCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.DAILY_PLANNER_URL, newData);

	// 🔑 Return the updated task
	return task;
}

export async function updateCustodyInCache(id, newCustodyRecord) {
  const cachedData = await getCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.BOTTLE_TRACKER_URL);
	if (!cachedData) return {};

  let containerList = Array.isArray(cachedData)
    ? cachedData
    : Array.isArray(cachedData?.data)
      ? cachedData.data
      : [];
  // find the matching container
  const index = containerList.findIndex(c => c.id === id);
  if (index === -1) return {};

  const container = containerList[index]
  // ensure custodyTrail exists
  if (!Array.isArray(container.custodyTrail)) {
    container.custodyTrail = [];
  }
  // append new custody record
  container.custodyTrail.push(newCustodyRecord);
  // Put back in original structure
  const newData = Array.isArray(cachedData) ? containerList : {...cachedData, data: containerList};
  await updateCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.BOTTLE_TRACKER_URL, newData);

  return containerList[index]; 
}

export async function updateCacheVerifcationData(data) {
	const existingData = await getCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.FIELD_ITEMS_VERIFY_URL) || [];
	const mergedItems = updateVerificationItems(existingData, data?.items || []);
  
	return await updateCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.FIELD_ITEMS_VERIFY_URL, mergedItems);
}

export async function updateCacheFieldItemAssigned(assignedData) {
	const cachedData = await getCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.FIELD_ITEMS_URL) ?? {};
	const updatedData = getUpdatedFieldItems(cachedData, assignedData?.items);
	await updateCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.FIELD_ITEMS_URL, updatedData);

	return updatedData;
}

export async function updateCacheFieldStatus(data) {	
	const formatData = await resetCalibrationStatus(data);
	await updateCacheData(CACHE_APP_DATA, CACHE_KEY_MAP.FIELD_ITEMS_STATUS_URL, formatData);
}

export async function getCacheData(cacheName, cacheKey) {
	const cache = await caches.open(cacheName);
	const response = await cache.match(cacheKey);

	return response ? await response.json() : null;
}

export async function updateCacheData(cacheName, cacheKey, newData) {
	const cache = await caches.open(cacheName);
	const response = new Response(JSON.stringify(newData), {
		headers: {'Content-Type': 'application/json'}
	});
	await cache.put(cacheKey, response);

	return newData;
}
